module.exports = __webpack_public_path__ + "static/media/img (yemen website).7cec1208.png";